import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'

import client from 'api'


export const fetchLookupData = createAsyncThunk('lookupData/fetchLookupData', async ({ lookupName, url, params }: any) => {
    const res = await client.get(url, { params })
    return { lookupName, params, data: res.data }
},
{
    condition: ({ lookupName, params, force }: any, { getState }) => {
        const { lookupData } = getState() as any
        const _params = new URLSearchParams(params)
        _params.sort() // Ensure consistent ordering for the key

        const status = lookupData[lookupName]?.[_params.toString() || 'noparams']?.status
        if ((status === 'loaded' && !force) || status === 'loading') {
            return false
        }

        return true
    }
})

export const lookupDataSelector = createSelector(
    [
        (state: any) => state.lookupData,
        (_: any, lookupName: string) => lookupName,
        (_: any, __: string, params: any) => params
    ],
    (lookupData: any, lookupName: string, params: any): any => {
        const _params = new URLSearchParams(Object.keys(params).reduce((acc: any, key: string) => {
            if (params[key] !== undefined && params[key] !== null) {
                acc[key] = params[key]
            }
            return acc
        }, {}))
        _params.sort() // Ensure consistent ordering for the key
        return lookupData[lookupName]?.[_params.toString() || 'noparams'] || lookupData['_empty']
    }
)

const LookupDataSlice = createSlice({
    name: 'lookupData',
    initialState: {
        _empty: { status: 'notloaded', data: [] }
    } as any,
    reducers: {
        setLookupData: (state, action) => {
            const { lookupName, params, status, data } = action.payload
            if (!state[lookupName]) {
                state[lookupName] = {}
            }

            const _params = new URLSearchParams(params)
            _params.sort() // Ensure consistent ordering for the key

            state[lookupName][_params.toString() || 'noparams'] = {
                status,
                data
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLookupData.pending, (state, action) => {
            const { lookupName, params } = action.meta.arg
            if (!state[lookupName]) {
                state[lookupName] = {}
            }

            const _params = new URLSearchParams(params)
            _params.sort() // Ensure consistent ordering for the key

            if (!state[lookupName][_params.toString() || 'noparams']) {
                state[lookupName][_params.toString() || 'noparams'] = {}
            }
            state[lookupName][_params.toString() || 'noparams'].status = 'loading'
        })
        builder.addCase(fetchLookupData.rejected, (state, action) => {
            const { lookupName, params } = action.meta.arg
            const _params = new URLSearchParams(params)
            _params.sort() // Ensure consistent ordering for the key
            state[lookupName][_params.toString() || 'noparams'].status = 'error'
        })
        builder.addCase(fetchLookupData.fulfilled, (state, action) => {
            const { lookupName, params, data } = action.payload
            const _params = new URLSearchParams(params)
            _params.sort() // Ensure consistent ordering for the key
            state[lookupName][_params.toString() || 'noparams'] = {
                status: 'loaded',
                data
            }
        })
    }
})

export const { setLookupData } = LookupDataSlice.actions
export default LookupDataSlice.reducer
